import React, { useRef, useState, useEffect } from "react";
import { useQuery, gql, useMutation, useLazyQuery } from "@apollo/client";
import { Select } from "antd";
import "./globalAdmin.css";
import { Layout, Modal, Col, Row, Upload, message, Input, Pagination } from "antd";
import { ExportOutlined, square } from "@ant-design/icons";
import { SquarePen } from "lucide-react";
import { validationRegexAmount, validationRegexOnlyAlpha } from "../../regex/regex";
import TextInputField from "../../reusableField/TextInputField2";
import CreateClientImage from "../../Images/add-new-profile-photo.png";
import { Upload_Document, List_All_Super_Admins, Add_update_super_admins, Role_Account_Query } from "../../services/userAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import defaultProfile from "../../Images/Darts-Logo.png";
import { CircularProgress } from "@mui/material";
import ImageUploadCrop from "../imageUploadCrop";
import { SearchOutlined } from "@ant-design/icons";
import { FaEye, FaEyeSlash } from "react-icons/fa";
const { Content } = Layout;

export default function Globaladmin() {
  const navigate = useNavigate();
  const usersData = [
    { name: "Venkata Sumanth" },
    { name: "Venkata Sumanth" },
    { name: "Venkata Sumanth" },
    { name: "Venkata Sumanth" },
  ];
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const imageRef = useRef(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [users, setUsers] = useState(usersData);
  const [clientImage, setClientImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [uploadedFilename, setUploadedFilename] = useState(null);
  const [isPickingColor, setIsPickingColor] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [touched, setTouched] = useState({});
  const [maskedPassword, setMaskedPassword] = useState();
  const [actualPassword, setActualPassword] = useState("");
  const [isImageChanged, setIsImageChanged] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const location = useLocation();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    emailId: "",
    password: "",
    contactNumber: "",
    clientImage: "",
    imageUrl: "",
    mainLogoUrl: "",
    id: "",
    userId: null,
    userRole: null,
  });

  const { data: roleData, loading: roleLoading, error: roleError } = useQuery(Role_Account_Query, {
    variables: { accountId: 1 },
    skip: false,
    onError: (err) => {
      console.error("Error fetching roles:", err.message);
      message.error("Failed to fetch roles. Please try again.");
    },
  });

  const roleOptions = React.useMemo(() => {
    if (roleLoading || roleError || !roleData?.getAllJobrole) return [];
    return roleData?.getAllJobrole?.map((role) => ({
      value: role.id,
      label: role.name,
      disabled: role.name === "Marketing", // Add disabled property here
    }));
  }, [roleData, roleLoading, roleError]);

  const [page, setPage] = useState(1);
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = "Enter user's name.";
    }

    // Email Validation
    if (!formData.emailId) {
      newErrors.emailId = "Enter email ID.";
    } else if (!emailRegex.test(formData.emailId)) {
      newErrors.emailId = "Please enter a valid email address.";
    }

    const hasExistingImage =
      selectedUser?.profilePicture?.trim() || formData.imageUrl?.trim();
    const hasNewImage =
      clientImage?.trim() || uploadedFilename?.trim();

    if (!hasExistingImage && !hasNewImage) {
      newErrors.clientImage = "Please upload an image";
      isValid = false;
    }

    // Password Validation
    if (!formData.password) {
      newErrors.password = "Enter password.";
    }

    // Contact Number Validation
    if (!formData.contactNumber) {
      newErrors.contactNumber = "Enter contact number.";
    } else if (!/^[6-9]\d{9}$/.test(formData.contactNumber)) {
      newErrors.contactNumber =
        "Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.";
    }

    // User Role Validation
    if (!formData.userRole) {
      newErrors.userRole = "Please select a user role.";
      isValid = false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    setIsFormValid(validateForm());
  }, [formData]);

  const [addUpdateSuperAdmin, { addUpdateSuperAdminloading, addUpdateSuperAdminerror }] = useMutation(Add_update_super_admins);
  const [selectedUser, setSelectedUser] = useState(null);
  useEffect(() => {
    if (selectedUser) {
      setFormData({
        id: selectedUser.id,
        name: selectedUser.firstName,
        emailId: selectedUser.email,
        password: "",
        contactNumber: selectedUser.contactNumber,
        userRole: selectedUser.roleId,
      });
    }
  }, [selectedUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      name: true,
      emailId: true,
      password: true,
      contactNumber: true,
      clientImage: true,
      userRole: true,
    });

    if (!validateForm()) {
      message.error("Please fix the errors before submitting.");
      return;
    }

    const userId = selectedUser?.id ?? formData.userId ?? null;

    try {
      const { data } = await addUpdateSuperAdmin({
        variables: {
          updatedUser: {
            userId: selectedUser?.id ?? formData.userId ?? null,
            firstName: formData.name,
            surname: "",
            email: formData.emailId,
            password: formData.password,
            contactNumber: formData.contactNumber,
            profilePicture: uploadedFilename,
            userId: userId,
            userStatus: null,
            userType: null,
            roleId: formData.userRole,
          },
        },
      });

      if (data?.addUpdateSuperAdmins?.success) {
        message.success(userId ? "User updated successfully!" : "User added successfully!");
        if (formData.userId) {
          editHandleCancel();
        } else {
          handleCancel();
        }

        setFormData({
          name: "",
          emailId: "",
          password: "",
          contactNumber: "",
          userId: null,
          imageUrl: "",
          mainLogoUrl: "",
          userType: null,
          clientImage: "",
          userRole: null,
        });

        setTouched({});
        setErrors({});
        setClientImage(null);
        setIsImageChanged(false);
        setIsModalVisible(false);
        setUploadedFilename(null);
        handleCancel();
        setSelectedUser(null);
        setResetTrigger((prev) => !prev);

        refetch();
        navigate("/global-admin");
      } else {
        message.error(data?.addUpdateSuperAdmins?.message || "Something went wrong!");
      }
    } catch (error) {
      const errorMessage = error.graphQLErrors?.[0]?.message || "Something went wrong!";
      message.error(errorMessage);
    }
  };

  const handleImageClick = (e) => {
    if (!isPickingColor) return;
    e.preventDefault();
    e.stopPropagation();

    if (selectedColor) {
      setFormData((prevData) => ({
        ...prevData,
        brandColor: selectedColor.hex,
      }));
    }
    setIsPickingColor(false);
    if (imageRef.current) {
      imageRef.current.classList.remove("color-picking-cursor");
      imageRef.current.classList.remove("active-picker-border");
    }
  };

  const [uploadDocument] = useMutation(Upload_Document, {
    onCompleted: (data) => {
      if (data.uploadDocument.success) {
        const filename = data.uploadDocument?.data?.data?.filename;
        const imageUrl = data.uploadDocument?.data?.data?.url;
        setUploadedFilename(filename);

        setFormData((prevData) => ({
          ...prevData,
          imageUrl: imageUrl && imageUrl.trim() !== "" ? imageUrl : defaultProfile,
        }));
        message.success("Image uploaded successfully!");
      } else {
        message.error("Failed to upload image: " + data.uploadDocument.message);
      }
    },
    onError: (error) => {
      message.error("Upload failed: " + error.message);
    },
  });

  const handleImageChange = ({ file }) => {
    if (!file) {
      message.error("Invalid file object.");
      return;
    }

    const allowedFormats = ["image/jpeg", "image/png"];
    const actualFile = file.originFileObj || file;

    if (!actualFile) {
      message.error("No valid file detected.");
      return;
    }

    if (!allowedFormats.includes(actualFile.type)) {
      message.error("Invalid file format. Only JPEG and PNG are allowed.");
      return;
    }

    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        setClientImage(e.target.result);
        setIsImageChanged(true);
      };
      reader.readAsDataURL(actualFile);

      uploadDocument({
        variables: {
          s3folder: "COMPANY_LOGO",
          document: actualFile,
        },
        context: {
          useMultipart: true,
        },
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        clientImage: "",
      }));
    } catch (error) {
      console.error("Error handling the file:", error);
      message.error("File upload failed.");
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
    setFormData({
      name: "",
      emailId: "",
      password: "",
      contactNumber: "",
      imageUrl: "",
      clientImage: "",
    });
    setClientImage("");
    setErrors({});
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      emailId: "",
      password: "",
      contactNumber: "",
      imageUrl: "",
      mainLogoUrl: "",
    });
    setClientImage(null);
    setTouched({});
    setErrors({});
    setIsModalVisible(false);
    setIsImageChanged(false);
    setUploadedFilename(null);
    setSelectedUser(false);
    setResetTrigger((prev) => !prev);
  };

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

  const editShowModal = (user) => {
    const newFormData = {
      userId: user?.id || "",
      name: user?.firstName || "",
      emailId: user?.email || "",
      password: user?.password || "",
      contactNumber: user?.contactNumber || "",
      imageUrl: user?.profilePicture || defaultProfile,
      userRole: user.roleId || null,
    };

    setFormData(newFormData);
    setIsImageChanged(false);
    setClientImage(user?.profilePicture || defaultProfile);
    setUploadedFilename(null);

    if (user?.profilePicture?.trim()) {
      setErrors((prev) => ({
        ...prev,
        clientImage: "",
        imageUrl: "",
      }));
    }

    setSelectedUser(user);
    setIsEditModalVisible(true);
  };

  useEffect(() => {
    if (selectedUser) {
      setFormData({
        userId: selectedUser.id,
        name: selectedUser.firstName,
        emailId: selectedUser.email,
        password: selectedUser.password,
        contactNumber: selectedUser.contactNumber,
        imageUrl: selectedUser.profilePicture,
        userRole: selectedUser.roleId,
      });
    }
  }, [selectedUser]);

  const editHandleCancel = () => {
    setFormData({
      name: "",
      emailId: "",
      password: "",
      contactNumber: "",
      imageUrl: "",
      userId: null,
    });
    setClientImage(null);
    setTouched({});
    setErrors({});
    setSelectedUser(false);
    setIsEditModalVisible(false);
  };

  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [isDeactivating, setIsDeactivating] = useState(false);

  const showDeleteModal = (user) => {
    setSelectedUser(user);
    setDeleteModalVisible(true);
  };

  const handleDeleteUser = async (user) => {
    setIsDeactivating(true);
    try {
      const newStatus = user.userStatus === 1 ? 0 : 1;

      await addUpdateSuperAdmin({
        variables: {
          updatedUser: {
            userId: user.id,
            userStatus: newStatus,
            firstName: null,
            surname: null,
            email: null,
            password: null,
            contactNumber: null,
            profilePicture: null,
            userType: null,
            roleId: null,
          },
        },
      });

      message.success(`User ${newStatus === 0 ? "deactivated" : "reactivated"} successfully`);

      refetch();
      setDeleteModalVisible(false);
      setIsEditModalVisible(false);
    } catch (error) {
      message.error("Failed to update user status");
    } finally {
      setIsDeactivating(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Remove spaces from the beginning of the input
    const trimmedValue = value.replace(/^\s+/, "");

    setFormData((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));

    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    // Keep your existing validation logic here if you have any
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setActualPassword(value);
    setMaskedPassword("*".repeat(value.length));
    setFormData({ ...formData, password: value });
  };

  const [search, setSearch] = useState("");
  const [cursor, setCursor] = useState(null);
  const [cursorMap, setCursorMap] = useState({ 1: null });
  const [fetchAdmins, { loading, error, data, refetch }] = useLazyQuery(List_All_Super_Admins, {
    fetchPolicy: "network-only",
  });
  const [filteredData, setFilteredData] = useState([]);
  const limit = 5;

  const debouncedFetchAdmins = debounce((searchString) => {
    fetchAdmins({
      variables: {
        searchString: searchString || null,
        pagingCriteria: {
          limit,
          cursor: cursor,
          sortByField: "created_at",
          sortOrder: "desc",
        },
      },
    });
  });

  useEffect(() => {
    if (!search) {
      fetchAdmins({
        variables: {
          searchString: null,
          pagingCriteria: {
            limit,
            cursor: null,
            sortByField: "created_at",
            sortOrder: "desc",
          },
        },
      });
    } else {
      debouncedFetchAdmins(search);
    }
  }, [search, fetchAdmins]);

  useEffect(() => {
    if (data?.listAllSuperadmins?.data) {
      const filtered = data.listAllSuperadmins.data.filter((user) => {
        const firstName = user.firstName?.toLowerCase() || "";
        const surname = user.surname?.toLowerCase() || "";
        return firstName.includes(search.toLowerCase()) || surname.includes(search.toLowerCase());
      });
      setFilteredData(filtered);

      const pageMeta = data.listAllSuperadmins.pageMeta;
      if (pageMeta) {
        setCursorMap((prev) => {
          const updated = { ...prev };
          if (pageMeta.nextPage) updated[page + 1] = pageMeta.nextPage;
          if (pageMeta.previousPage && page > 1) updated[page - 1] = pageMeta.previousPage;
          return updated;
        });
      }
    }
  }, [search, data, page]);

  useEffect(() => {
    debouncedFetchAdmins(search);
  }, [search, cursor]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  function handleNextPage() {
    if (data?.listAllSuperadmins?.pageMeta?.nextPage) {
      setCursor(data.listAllSuperadmins.pageMeta.nextPage);
      setPage(page + 1);
    } else {
      console.log("No next page available.");
    }
  }

  const handlePreviousPage = () => {
    if (data?.listAllSuperadmins?.pageMeta?.previousPage && page > 1) {
      setCursor(data.listAllSuperadmins.pageMeta.previousPage);
      setPage(page - 1);
    } else {
      console.log("No previous page available.");
    }
  };

  const inputRefActivity = useRef(null);

  useEffect(() => {
    if (inputRefActivity.current) {
      inputRefActivity.current.focus();
    }
  }, []);

  const inputRefName = useRef(null);

  return (
    <Content className="content">
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-4px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div className="main-content">
        <div className="global-admin-header">
          <h2 className="user-title">User Information</h2>
          <div className="header-content">
            <div className="search-container-global-admin">
              <Input
                placeholder="Search user..."
                className="global-admin-search-input"
                value={search}
                onChange={handleSearchChange}
                suffix={<SearchOutlined style={{ color: '#6B7280', fontSize: '16px' }} />}
                onDrop={(e) => e.preventDefault()}
                onDragOver={(e) => e.preventDefault()}
                style={{ height: "45px" }}
              />
            </div>
            <button className="global-admin-addNew-button" onClick={showModal}>
              Add&nbsp;New
            </button>
          </div>
        </div>
        <div className="user-list-container">
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "20px", color: "#AD0101" }}>
              <CircularProgress style={{ color: "#AD0101" }} />
            </div>
          ) : (
            <Paper
              sx={{
                width: "100%",
                maxWidth: "100%",
                margin: "0 auto",
                overflow: "hidden",
                boxShadow: "none",
                marginTop: "-30px",
                borderRadius: "8px",
              }}
            >
              <TableContainer sx={{ borderRadius: "8px", overflow: "hidden" }}>
                <Table>
                  <TableHead style={{ backgroundColor: "#FFFFFF" }}>
                    <TableRow
                      sx={{
                        "&:last-child td": {

                          borderBottom: "1px solid #E5E7EB",
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          borderBottom: "1px solid #E5E7EB",
                          width: "35%",
                          padding: "8px 16px",
                          color: "#000000",
                        }}
                      >
                        User Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          borderBottom: "1px solid #E5E7EB",
                          width: "30%",
                          padding: "10px 16px",
                          color: "#000000",
                        }}
                      >
                        Role Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          borderBottom: "1px solid #E5E7EB",
                          width: "15%",
                          padding: "10px 16px",
                          color: "#000000",
                        }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          borderBottom: "1px solid #E5E7EB",
                          width: "10%",
                          padding: "10px 16px",
                          color: "#000000",
                          textAlign: "right",
                        }}
                      >
                        Edit User
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.listAllSuperadmins?.data?.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={4} style={{ textAlign: "center", padding: "40px", fontFamily: "Inter", fontSize: "14px", color: "#666" }}>
                          No user found
                        </TableCell>
                      </TableRow>
                    )}
                    {data?.listAllSuperadmins?.data?.map((user) => (
                      <TableRow
                        key={user.id}
                        sx={{
                          "&:hover": {
                            backgroundColor: "transparent !important",
                          },
                          "& td": {
                            backgroundColor: "transparent !important",
                          },
                          "&:last-child td": {
                            borderBottom: 0,
                          },
                        }}
                      >
                        <TableCell
                          style={{
                            borderBottom: "1px solid #E5E7EB",
                            padding: "16px 16px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div className="user-avatar" style={{ width: "32px", height: "32px" }}>
                              <img
                                src={user.profilePicture ? user.profilePicture : defaultProfile}
                                alt="No Profile"
                                className="user-profile-image"
                                style={{ width: "32px", height: "32px", borderRadius: "50%", objectFit: "cover" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#1F2020",
                                fontFamily: "Inter",
                              }}
                            >
                              {user.surname} {user.firstName}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell
                          style={{
                            borderBottom: "1px solid #E5E7EB",
                            padding: "10px 16px",
                          }}
                        >
                          <div style={{ fontSize: "14px", fontWeight: "400", color: "#1F2020", fontFamily: "Inter" }}>{user.roleName || ""}</div>
                        </TableCell>
                        <TableCell
                          style={{
                            borderBottom: "1px solid #E5E7EB",
                            padding: "10px 16px",
                          }}
                        >
                          {/* Status cell - make badge smaller */}
                          <span

                            style={{
                              display: "inline-block",
                              padding: "2px 8px",
                              borderRadius: "20px",
                              fontFamily: "Inter",
                              fontWeight: "500",
                              fontSize: "0.72rem",
                              backgroundColor: user.userStatus === 1 ? "#DCFCE7" : "#FECACA",
                              color: user.userStatus === 1 ? "#16A34A" : "#DC2626",
                              whiteSpace: "nowrap",
                              lineHeight: "1.6",
                            }}
                          >

                            {user.userStatus === 1 ? "Active" : "Inactive"}
                          </span>
                        </TableCell>
                        <TableCell
                          style={{
                            borderBottom: "1px solid #E5E7EB",
                            padding: "10px 16px",
                            textAlign: "right",
                          }}
                        >
                          {/* Edit User button - smaller, tighter */}
                          <button
                            className="global-admin-edit-button"
                            onClick={() => editShowModal(user)}
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              padding: "0",
                              fontFamily: "Inter",
                              fontSize: "0.75rem",
                              fontWeight: "400",
                              color: "#6B7280",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "3px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Edit User
                            <SquarePen size={12} style={{ marginLeft: "1px" }} />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}
          <div className="global-admin-pagination">
            <Pagination
              current={page}
              pageSize={limit}
              total={data?.listAllSuperadmins?.pageMeta?.totalCount || 0}
              onChange={(newPage) => {
                if (cursorMap[newPage] !== undefined) {
                  setCursor(cursorMap[newPage]);
                  setPage(newPage);
                } else if (newPage === 1) {
                  setCursor(null);
                  setPage(1);
                }
              }}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
              showSizeChanger={false}
            />
          </div>
        </div>

        {/* Modal for Adding New User */}
        <Modal
          title={
            <span>
              Product Access <span style={{ color: "#AD0101" }}>*</span>
            </span>
          }
          open={isModalVisible}
          onCancel={handleCancel}
          closable={false}
          footer={null}
          centered
          width={1000}
          style={{ marginLeft: "4%" }}
        >
          <div className="add-user-container">
            <Row className="user-form" style={{ display: "flex", alignItems: "center", marginLeft: "3%" }}>
              <Col span={24}>
                <Row gutter={[16, 16]} align="middle">
                  <Col sm={4} xs={8} md={4} lg={4} style={{ flexShrink: 0 }}>
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      {/* <span style={{ color: '#AD0101', fontSize: '18px', position: 'absolute', top: '-2px', right: '20px', zIndex: 1 }}>*</span> */}
                      <ImageUploadCrop
                        onImageUpdate={(imageUrl, filename) => {
                          setClientImage(imageUrl);
                          setUploadedFilename(filename);
                          setIsImageChanged(true);
                          setFormData((prev) => ({
                            ...prev,
                            imageUrl,
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            clientImage: "",
                          }));
                        }}
                        initialImage={
                          isImageChanged ? null : clientImage || formData.imageUrl || formData.mainLogoUrl
                        }
                        resetTrigger={resetTrigger}
                      />
                      {touched.clientImage && errors.clientImage && (
                        <div className="createClientErrors">{errors.clientImage}</div>
                      )}
                    </div>
                  </Col>
                  <Col sm={20} xs={16} md={20} lg={20}>
                    <Row gutter={[16, 16]}>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                          User's Name <span style={{ color: "#AD0101" }}>*</span>
                        </label>

                        <input
                          className="EditUserTextInput"
                          ref={inputRefName}
                          name="name"
                          value={formData.name}
                          placeholder="Enter User's Name"
                          feedbackMessage="Please input the user name."
                          validationRegex={validationRegexOnlyAlpha}
                          onChange={handleInputChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSubmit();
                            }
                          }}
                        />

                        {touched.name && errors.name && (
                          <div className="createClientErrors">{errors.name}</div>
                        )}
                      </Col>

                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                          User's Email ID <span style={{ color: "#AD0101" }}>*</span>
                        </label>

                        <input
                          className="EditUserTextInput"
                          name="emailId"
                          value={formData.emailId}
                          placeholder="Enter User's Email ID"
                          feedbackMessage={errors.emailId}
                          error={!!errors.emailId}
                          onChange={handleInputChange}
                          ref={inputRefActivity}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSubmit();
                            }
                          }}
                        />

                        {touched.emailId && errors.emailId && (
                          <div className="createClientErrors">{errors.emailId}</div>
                        )}
                      </Col>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                          Password <span style={{ color: "#AD0101" }}>*</span>
                        </label>

                        <div className="password-field-container-edituser">
                          <input
                            className="EditUserTextInput"
                            name="password"
                            value={formData.password}
                            placeholder="Enter Password"
                            type={passwordVisible ? "text" : "password"}
                            autoComplete="off"
                            feedbackMessage="Please input the password"
                            onChange={(e) => {
                              let value = e.target.value;

                              // Remove spaces from the beginning
                              value = value.replace(/^\s+/, "");

                              setFormData((prev) => ({
                                ...prev,
                                password: value,
                              }));

                              // Call your existing password validation
                              handlePasswordChange({
                                ...e,
                                target: {
                                  ...e.target,
                                  value: value,
                                },
                              });
                            }}
                            onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();

                              setFormData((prev) => ({
                                ...prev,
                                password: trimmedValue,
                              }));
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleSubmit();
                              }
                            }}
                          />

                          {formData.password && (
                            <span
                              className="eye-icon"
                              onClick={() => setPasswordVisible(!passwordVisible)}
                            >
                              {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                            </span>
                          )}
                        </div>

                        {touched.password && errors.password && (
                          <div className="createClientErrors">
                            {errors.password}
                          </div>
                        )}
                      </Col>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>Contact Number<span style={{ color: '#AD0101' }}>*</span> </label>
                        <input
                          className="EditUserTextInput"
                          name="contactNumber"
                          value={formData.contactNumber}
                          placeholder="Enter User's Contact No."
                          feedbackMessage="Please input the contact number."
                          onChange={handleInputChange}
                          validationRegex={validationRegexAmount}
                          maxLength={10}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit();
                            }
                          }}
                        />
                        {touched.contactNumber && errors.contactNumber && (
                          <div className="createClientErrors">{errors.contactNumber}</div>
                        )}
                      </Col>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>User Role <span style={{ color: '#AD0101' }}>*</span></label>
                        <Select
                          options={roleOptions}
                          value={roleOptions.find((option) => option.value === formData.userRole)}
                          onChange={(value) => setFormData((prev) => ({ ...prev, userRole: value }))}
                          placeholder="Select User Role"
                          style={{ width: "100%", borderRadius: "20px" }}
                          optionLabelProp="label"
                          showSearch
                          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        >
                          {roleOptions.map((option) => (
                            <Select.Option
                              key={option.value}
                              value={option.value}
                              label={option.label}
                            // disabled={option.label === "Marketing"} // Disable "Marketing" role
                            >
                              {option.label}
                            </Select.Option>
                          ))}
                        </Select>
                        {touched.userRole && !formData.userRole && (
                          <div className="createClientErrors">Please select a user role.</div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="global-admin-modal-footer">
              <button className="global-admin-discard-button" onClick={handleCancel}>
                Discard
              </button>
              <button className="global-admin-apply-button" onClick={handleSubmit} disabled={loading}>
                {loading ? "Submitting..." : "Apply"}
              </button>
            </div>
          </div>
        </Modal>

        {/* Modal for Edit Users */}
        <Modal
          title="Edit User"
          open={isEditModalVisible}
          onCancel={editHandleCancel}
          footer={null}
          centered
          width={1000}
          closable={false}
          style={{ marginLeft: "4%" }}
        >
          <div className="add-user-container">
            <Row className="user-form" style={{ display: "flex", alignItems: "center", marginLeft: "3%" }}>
              <Col span={24}>
                <Row gutter={[16, 16]} align="middle">
                  <Col sm={4} xs={8} md={4} lg={4} style={{ flexShrink: 0 }}>
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      <span style={{ color: '#AD0101', fontSize: '18px', position: 'absolute', top: '-2px', right: '20px', zIndex: 1 }}>*</span>
                      <Upload
                        style={{ marginLeft: "-22%" }}
                        name="clientImage"
                        showUploadList={false}
                        customRequest={handleImageChange}
                        accept="image/*"
                      >
                        <div className="global-admin-image-upload-circle">
                          {clientImage ? (
                            <img
                              ref={imageRef}
                              src={clientImage}
                              alt="Uploaded"
                              className="uploaded-image"
                              onClick={handleImageClick}
                            />
                          ) : formData.imageUrl ? (
                            <img
                              ref={imageRef}
                              src={formData.imageUrl}
                              alt="Existing Client"
                              className="uploaded-image"
                              onClick={handleImageClick}
                            />
                          ) : formData.mainLogoUrl ? (
                            <img
                              ref={imageRef}
                              src={formData.mainLogoUrl}
                              alt="Existing Logo"
                              className="uploaded-image"
                              onClick={handleImageClick}
                            />
                          ) : (
                            <img src={CreateClientImage} alt="Upload Icon" className="upload-icon" />
                          )}
                        </div>
                        {touched.clientImage && errors.clientImage && (
                          <div className="createClientErrors">{errors.clientImage}</div>
                        )}
                      </Upload>
                    </div>
                  </Col>
                  <Col sm={20} xs={16} md={20} lg={20}>
                    <Row gutter={[16, 16]}>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                          User's Name <span style={{ color: "#AD0101" }}>*</span>
                        </label>

                        <input
                          className="EditUserTextInput"
                          name="name"
                          value={formData.name}
                          placeholder="Enter User's Name"
                          feedbackMessage="Please input the user name."
                          validationRegex={validationRegexOnlyAlpha}
                          onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: "name",
                                value: e.target.value.replace(/^\s+/, ""),
                              },
                            })
                          }
                        />

                        {touched.name && errors.name && (
                          <div className="createClientErrors">{errors.name}</div>
                        )}
                      </Col>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>User's Email ID </label>
                        <input
                          className="EditUserTextInput"
                          name="emailId"
                          value={formData.emailId}
                          placeholder="Enter User's Email ID"
                          feedbackMessage={errors.emailId}
                          error={!!errors.emailId}
                          onChange={handleInputChange}
                        />
                        {touched.emailId && errors.emailId && <div className="createClientErrors">{errors.emailId}</div>}
                      </Col>

                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>Password </label>
                        <input
                          className="EditUserTextInput"
                          name="password"
                          value={formData.password}
                          placeholder="Enter Password"
                          type="password"
                          autoComplete="off"
                          feedbackMessage="Please input the password."
                          onChange={handlePasswordChange}
                        />
                        {touched.password && errors.password && <div className="createClientErrors">{errors.password}</div>}
                      </Col>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        <label style={{ fontSize: "15px", color: "#1C1B1F" }}>Contact Number <span style={{ color: '#AD0101' }}>*</span></label>
                        <input
                          className="EditUserTextInput"
                          name="contactNumber"
                          value={formData.contactNumber}
                          placeholder="Enter User's Contact No."
                          feedbackMessage="Please input the contact number."
                          onChange={handleInputChange}
                          validationRegex={validationRegexAmount}
                          maxLength={10}
                        />
                        {touched.contactNumber && errors.contactNumber && (
                          <div className="createClientErrors">{errors.contactNumber}</div>
                        )}
                      </Col>
                      <Col sm={12} xs={24} md={12} lg={12}>
                        {/* <label style={{ fontSize: "15px", color: "#1C1B1F" }}>User Role <span style={{ color: '#AD0101' }}>*</span></label> */}
                        <Select
                          options={roleOptions}
                          value={roleOptions.find((option) => option.value === formData.userRole)}
                          onChange={(value) => setFormData((prev) => ({ ...prev, userRole: value }))}
                          placeholder="Select User Role"
                          style={{ width: "100%" }}
                          optionLabelProp="label"
                          showSearch
                          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        >
                          {roleOptions.map((option) => (
                            <Select.Option
                              key={option.value}
                              value={option.value}
                              label={option.label}
                            >
                              {option.label}
                            </Select.Option>
                          ))}
                        </Select>
                        {touched.userRole && !formData.userRole && (
                          <div className="createClientErrors">Please select a user role.</div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="modal-footer">
              {selectedUser && (
                <button
                  style={{
                    color: selectedUser.userStatus === 1 ? "#AD0101" : "green",
                    border: `1px solid ${selectedUser.userStatus === 1 ? "#AD0101" : "green"}`,
                    padding: "5px 10px",
                    borderRadius: "6px",
                    width: "150px",
                    height: "35px",
                  }}
                  className="global-admin-delete-icon-button"
                  onClick={() => showDeleteModal(selectedUser)}
                >
                  <span style={{ color: selectedUser.userStatus === 1 ? "#AD0101" : "green" }}>
                    {selectedUser.userStatus === 1 ? "Deactivate User" : "Activate User"}
                  </span>
                </button>
              )}
              <div className="edit-cancel-and-apply" style={{ display: "flex", gap: "14px", width: "113%", justifyContent: "end" }}>
                <button className="global-admin-discard-button" onClick={editHandleCancel}>
                  Cancel
                </button>
                <button className="global-admin-apply-button" onClick={handleSubmit}>
                  Apply
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Modal for Delete user */}
        {
          isDeleteModalVisible && selectedUser && (
            <Modal
              open={isDeleteModalVisible}
              onCancel={() => setDeleteModalVisible(false)}
              footer={null}
              centered
              width={500}
              closable={false}
            >
              <p>
                Do you want to {selectedUser.userStatus === 1 ? "deactivate" : "activate"} this
                <span style={{ fontWeight: "bold" }}>{selectedUser.name} User?</span>
              </p>
              <div className="delete-modal-footer">
                <button
                  style={{
                    backgroundColor: selectedUser.userStatus === 1 ? "#AD0101" : "green",
                    border: `1px solid ${selectedUser.userStatus === 1 ? "#AD0101" : "green"}`,
                    opacity: isDeactivating ? 0.7 : 1,
                    cursor: isDeactivating ? "not-allowed" : "pointer",
                  }}
                  className="global-admin-Delete-button"
                  onClick={() => handleDeleteUser(selectedUser)}
                  disabled={isDeactivating}
                >
                  {isDeactivating ? (
                    <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                  ) : (
                    selectedUser.userStatus === 1 ? "Deactivate User" : "Activate User"
                  )}
                </button>
                <button className="global-admin-Cancel-button" onClick={() => setDeleteModalVisible(false)}>
                  Cancel
                </button>
              </div>
            </Modal>
          )
        }
      </div >
    </Content >
  );
}